<h1 class="ib-heading ib-heading--type-4  ib-heading--type-4--responsive u-mt-medium">{{'SEATS_DISRUPTION_OPTION_2_TITLE' | translate}}</h1>
<div class="ib-profile-form u-mt-small u-pt-none u-mb-medium u-pb-none">
    <div class="ib-profile-form ib-profile-form--less u-pl-small u-pr-small">
        <span class="ib-profile-form__title ib-profile-form__subtitle--small ib-profile-form__subtitle--small-no-padding u-mb-none">{{'SEATS_DISRUPTION_OPTION_2_SUBTITLE' | translate}}</span>
        <div class="u-display-flex ib-flex--flex-end">
            <button
                class="ib-button ib-button--inverse ib-button--w-big-special ib-button--w-big-fullmobile u-mt"
                type="button"
                (click)="navigateToSeatmap()">
                {{'GO_TO_SEATMAP' | translate}}
            </button>
        </div>
    </div>
</div>